import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { cn } from '@shared/lib';
import { Toaster } from '@shared/ui';
import { useAuth, isAuthenticatedUser } from '@entities/auth';
import { Header, Sidebar } from '@widgets/navigation';
import { formatPathname } from '@shared/lib/hooks';

export const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const pathName = formatPathname(pathname);

  if (
    !isAuthenticatedUser(user) ||
    (!isAuthenticatedUser(user) && pathname && !loading)
  ) {
    return <Navigate to={`/?from=${pathname}`} />;
  }

  const isPathEventCalendar = pathName === 'event-calendar';
  const isPathAccountSettings = pathName === 'account-settings';

  return (
    <>
      <Header />
      <div
        className={cn('flex h-[calc(100%_-_3rem_+_1px)] border-collapse', {
          'h-fit': pathName === '/event-calendar',
        })}
      >
        {!isPathEventCalendar && (
          <nav className="border-r bg-efl-blue">
            <Sidebar
              role={user.role}
              memberStatus={user?.membership_status}
              stripe_link={
                user.role === 'admin' || user.role === 'trainer'
                  ? user.stripe_link
                  : undefined
              }
            />
          </nav>
        )}
        <main
          className={cn('flex-1 bg-secondary/10 px-2 pb-1 pt-4', {
            'block flex-auto overflow-y-hidden ': isPathEventCalendar,
            'gap-x-2 overflow-y-hidden': isPathAccountSettings,
          })}
        >
          <Outlet />
        </main>
        <Toaster expand={true} richColors />
      </div>
    </>
  );
};
